import React, { useEffect, useRef } from 'react';
import './Popup.css';

const Popup = ({ isVisible, togglePopup }) => {
  const bodyStyleRef = useRef({});
  const htmlStyleRef = useRef({});
  const scrollYRef = useRef(0);

  useEffect(() => {
    if (!isVisible) return;

    const body = document.body;
    const html = document.documentElement;
    const scrollY = window.scrollY || window.pageYOffset || 0;
    const scrollbarGap = window.innerWidth - document.documentElement.clientWidth;

    scrollYRef.current = scrollY;
    bodyStyleRef.current = {
      overflow: body.style.overflow,
      position: body.style.position,
      top: body.style.top,
      width: body.style.width,
      paddingRight: body.style.paddingRight,
    };
    htmlStyleRef.current = {
      overflow: html.style.overflow,
      paddingRight: html.style.paddingRight,
    };

    html.style.overflow = 'hidden';
    body.style.overflow = 'hidden';
    body.style.position = 'fixed';
    body.style.top = `-${scrollY}px`;
    body.style.width = '100%';
    if (scrollbarGap > 0) {
      body.style.paddingRight = `${scrollbarGap}px`;
      html.style.paddingRight = `${scrollbarGap}px`;
    }

    return () => {
      const prev = bodyStyleRef.current;
      const htmlPrev = htmlStyleRef.current;
      html.style.overflow = htmlPrev.overflow || '';
      html.style.paddingRight = htmlPrev.paddingRight || '';
      body.style.overflow = prev.overflow || '';
      body.style.position = prev.position || '';
      body.style.top = prev.top || '';
      body.style.width = prev.width || '';
      body.style.paddingRight = prev.paddingRight || '';
      window.scrollTo(0, scrollYRef.current);
    };
  }, [isVisible]);

  if (!isVisible) return null;

  return (
    <div className="popup-overlay" onClick={togglePopup}>
      <div className="popup-card" onClick={(e) => e.stopPropagation()}>
        <button className="popup-close" onClick={togglePopup}>
          ✕
        </button>

        <img
          src="/images/image8.png"
          alt="Tattoo artist"
          className="popup-avatar"
          loading="lazy"
          decoding="async"
          width="120"
          height="120"
        />

        <h2 className="popup-title">Готовы к новой татуировке?</h2>
        <p className="popup-text">
          Свяжитесь со мной в <strong>Telegram</strong>, чтобы обсудить эскиз и выбрать удобное время.
        </p>

        <a
          href="https://t.me/vikavikatattoo"
          target="_blank"
          rel="noopener noreferrer"
          className="popup-button"
        >
           Написать в Telegram
        </a>
      </div>
    </div>
  );
};

export default Popup;
